module.exports = __webpack_public_path__ + "img/06.132a1338.png";